import { render, staticRenderFns } from "./BusinessProcessDetail.vue?vue&type=template&id=0b2d8ba3&scoped=true&"
import script from "./BusinessProcessDetail.vue?vue&type=script&lang=js&"
export * from "./BusinessProcessDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2d8ba3",
  null
  
)

export default component.exports